
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class RelationshipTypeDialog extends SiteEntityDialog<RelationshipTypeRow, any> {
        protected getFormKey() { return RelationshipTypeForm.formKey; }
        protected getIdProperty() { return RelationshipTypeRow.idProperty; }
        protected getLocalTextPrefix() { return RelationshipTypeRow.localTextPrefix; }
        protected getNameProperty() { return RelationshipTypeRow.nameProperty; }
        protected getService() { return RelationshipTypeService.baseUrl; }
        protected getDeletePermission() { return RelationshipTypeRow.deletePermission; }
        protected getInsertPermission() { return RelationshipTypeRow.insertPermission; }
        protected getUpdatePermission() { return RelationshipTypeRow.updatePermission; }

        protected form = new RelationshipTypeForm(this.idPrefix);

    }
}